
<div>
    <div v-if="header">
        <div class="navigation-header pr-2" style="width: 750px;">
            <div class = "navigation-col-header remove-button pl-4">
                <v-icon >mdi-trash-can-outline</v-icon>
            </div>
            <div class = "navigation-col-header elevator">
                {{ $t('inc.unit.elevatorNo') }}
            </div>
            <div class = "navigation-col-header company">
                {{ $t('inc.company.exe') }}
            </div>
            <div class = "navigation-col-header number">
                {{ $t('repair.bid.label.number') }}
            </div>
            <div class = "navigation-col-header price">
                {{ $t('invoice.price.original') }}
            </div>
            <div class = "navigation-col-header price mr-2">
                {{ $t('invoice.price.recommended') }}
            </div>
        </div>
    </div>
    <v-hover
        v-if   = "!header"
        v-slot = "{ hover }"
    >
        <div
            v-if   = "unit"
            class  = "navigation-entry"
            :class = "border2"
        >
            <div
                class="remove-button"
                :class = "background(hover)"
            >
                <a @click="onRemove">
                    <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                </a>
            </div>
            <div
                class  = "elevator"
                :class = "background(hover)"
            >
                {{ unit.fabricNo }}
            </div>
            <div
                class  = "company"
                :class = "background(hover)"
            >
                {{ company }}
            </div>
            <div
                class  = "number"
                :class = "background(hover)"
            >
                {{ number }}
            </div>
            <div
                class  = "price"
                :class = "background(hover)"
            >
                {{ priceOriginal }}
            </div>
            <div
                class  = "price mr-2"
                :class = "background(hover)"
            >
                {{ priceRecommended }}
            </div>
        </div>
    </v-hover>
</div>
